import { render, staticRenderFns } from "./AccountTransactionCancelForm.vue?vue&type=template&id=0afd529a"
import script from "./AccountTransactionCancelForm.vue?vue&type=script&lang=js"
export * from "./AccountTransactionCancelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports